import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export const initialState = {
  settings: null,
  menu: null,
  slides: null,
  pages: [],
};

export default {
  state: {
    ...initialState,
  },
  mutations,
  actions,
  getters,
};
